<template>
  <div class="footer">
    <!-- <div :class="{ device: true, chooseDevice: current === 2 }" @click="tabClick(2)"></div> -->
    <!-- <div :class="{ number: true, chooseNumber: current === 3 }" @click="tabClick(3)"></div> -->
    <!-- <div :class="{ operation: true, chooseOperation: current === 2 }" @click="tabClick(2)"></div> -->
    <!-- 标准效果 -->
    <!-- <div :class="{ safe: true, chooseSafe: current === 1 }" @click="tabClick(1)"></div>
    <div class="foot-split"></div>
    <div class="number" :class="{ number: true, chooseNumber: current === 3 }" @click="tabClick(3)"></div> -->
    <!-- 带经营分析页面效果 -->
    <div :class="{ safe: true, chooseSafe: current === 1 }" @click="tabClick(1)"></div>
    <div class="st" :class="{ st: true, chooseSt: current === 3 }" @click="tabClick(3)"></div>
    <div class="business" :class="{ business: true, chooseBusiness: current === 5 }" @click="tabClick(5)"></div>
  </div>
</template>

<script>
export default {
  props: {
    current: {
      default: 1,
    },
  },
  methods: {
    tabClick(e) {
      console.log(e)

      if (this.current == e) {
        return;
      }
      // this.current = e;
      if (e == 2) {
        this.$router.replace("/operation");
      } else if (e == 1) {
        this.$router.replace("/safe");
      } else if (e == 3) {
        this.$router.replace("/check");
      } else if (e == 5) {
        this.$router.push("/business-analysis");
      }
    },
  },
};
</script>

<style lang="scss">
.footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: .2344rem;
  display: flex;
  // align-items: center;
  justify-content: center;
  //   background-color: #fff;
}
.safe {
  cursor: pointer;
  width: 2.1875rem;
  height: .2344rem;
  background-image: url("~@/assets/chongqing/safe.png");
  background-size: 100% 100%;
  position: relative;
  right: -0.0521rem;
}
.foot-split{
  width: .1719rem;
  height: .1302rem;
  background-image: url("https://dobaycdn.anasit.com/dashboard_images/foot-split.png");
  background-size: 100% 100%;
  position: relative;
  top: .0104rem;
}
.chooseSafe {
  cursor: pointer;
  background-image: url("~@/assets/chongqing/safe-active.png") !important;
}
.device {
  cursor: pointer;

  width: 0.6667rem;
  margin-left: -0.0833rem;
  height: .2344rem;
  background-image: url("https://dobaycdn.anasit.com/dashboard_images/device-noChoose.png");
  background-size: 100% 100%;
}
.chooseDevice {
  cursor: pointer;
  background-image: url("https://dobaycdn.anasit.com/dashboard_images/device-choosed.png") !important;
}
.number {
  cursor: pointer;
   width: 2.1875rem;
  // margin-left: 0.0208rem;
  height: .2344rem;
  background-image:url("~@/assets/chongqing/number.png");
  background-size: 100% 100%;
  position: relative;
  left: -0.0521rem;
}
.chooseNumber {
  cursor: pointer;
  background-image: url("~@/assets/chongqing/number-active.png") !important;
}
// 切换普通版就把这个打开
// .st {
//   cursor: pointer;
//   width: 2.0313rem;
//   height: 0.2135rem;
//   margin-left: -.0521rem;
//   background-image: url("https://dobaycdn.anasit.com/dashboard_images/st-noChoose.png");
//   background-size: 100% 100%;
// }
// .chooseSt {
//   cursor: pointer;
//   background-image: url("https://dobaycdn.anasit.com/dashboard_images/st-choosed.png") !important;
// }
.operation {
    cursor: pointer;
    width: 1.1458rem;
    height: .2344rem;
    background-image: url("~@/assets/operation.png");
    background-size: 100% 100%;
    position: relative;
}
.chooseOperation {
  cursor: pointer;
  background-image: url("~@/assets/operation-active.png") !important;
}
// 切换普通版就把这个下面都注释
.st {
  cursor: pointer;
  width: 1.1074rem;
  height: .2344rem;
  margin-left: 0;
  margin-right: -0.0521rem;
  background-image: url("https://dobaycdn.anasit.com/dashboard_images/shuzinot.png");
  // background-image: url("~@/assets/shuzinot.png");
  background-size: 100% 100%;
}
.chooseSt {
  cursor: pointer;
  background-image: url("https://dobaycdn.anasit.com/dashboard_images/shuzixuanzho.png") !important;
  // background-image: url("~@/assets/shuzixuanzho.png") !important;
}
.business {
  cursor: pointer;
  width: 2.1875rem;
  height: .2344rem;
  margin-left: 0;
  background-image: url("https://dobaycdn.anasit.com/dashboard_images/shopxnot.png");
  //  background-image: url("~@/assets/shopxnot.png");
  background-size: 100% 100%;
}
.chooseBusiness {
  cursor: pointer;
  background-image: url("https://dobaycdn.anasit.com/dashboard_images/shopxuanzho.png") !important;
  //  background-image: url("~@/assets/shopxuanzho.png") !important;
}

</style>
